import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import Vuetify from 'vuetify'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import notification from './modules/notification'
import loading from './modules/loading'
import auth from './modules/auth'
import localStoragePlugin from './plugins/localStorage'

Vue.use(Vuex)
Vue.use(Router)
Vue.use(Vuetify)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    roles: [],
    users: [],
    projects: [],
    gnipRules: [],
    theme: true
  },
  actions,
  getters,
  mutations,
  modules: { notification, loading, auth },
  plugins: [localStoragePlugin],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js